import { Pipe, PipeTransform } from '@angular/core';
import { GlaeubigerVersionDetailEntryMeta } from '../../../core/gb-api/model/glaeubigerVersionDetailEntryMeta';
import { TranslateService } from '@ngx-translate/core';
import { TranslateNamePipe } from './translate-name.pipe';

@Pipe({
  name: 'glaeubigerRolleCode'
})
export class GlaeubigerRolleCodePipe implements PipeTransform {
  constructor(
    private translate: TranslateService,
    private translateName: TranslateNamePipe
  ) {}

  transform(value: GlaeubigerVersionDetailEntryMeta): any {
    const glaeubigerRolle = value.glaeubigerrolle === 'ANDEREROLLE' ? '' : this.translate.instant(value.glaeubigerrolle);
    const glaeubigerCode = value.codeGlaeubigerrolle ? this.translateName.transform(value.codeGlaeubigerrolle.text) : '';
    return [glaeubigerRolle, glaeubigerCode].filter(Boolean).join(', ');
  }
}
